export { default } from './RecentlyReturnedEmptyContentPanel';



// WEBPACK FOOTER //
// ./app/components/borrowing/recentlyreturned/RecentlyReturnedEmptyContentPanel/index.js